import React, { useRef } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { UnlinkIcon } from '../../ui/icons/unlink-icon'

interface LinkToolbarProps {
  url: string | undefined
  update: (value: string) => void
  toggleShowFileManager: () => void
  remove: () => void
}

export const LinkSourceInput = ({
  update,
  url,
  toggleShowFileManager,
  remove,
}: LinkToolbarProps) => {
  const { t } = useTypedTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const handleURLChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    update(event.target.value)
  }
  return (
    <div className="flex justify-between items-center py-3 px-6">
      <label htmlFor="link-input" className="block text-heading-5">
        {t('components.core.text_editor.link_toolbar.link')}
      </label>
      <div className="flex border border-gray-200 rounded-lg w-2/3 h-[37px]">
        <input
          ref={inputRef}
          placeholder={t('components.core.text_editor.link_menu.placeholder')}
          type="text"
          style={{ width: 'inherit' }}
          className="flex flex-auto focus:outline-none pl-3 py-2.5 text-M w-full"
          value={url}
          onChange={handleURLChange}
        />
        {url && (
          <button
            type="button"
            className="px-3 cursor-pointer hover:bg-gray-100"
            onClick={remove}
            title={t('components.core.text_editor.link_menu.unlink')}
          >
            <UnlinkIcon />
          </button>
        )}
        <div className="w-px max-h-52 bg-divider03" />
        <button
          type="button"
          className=" cursor-pointer w-[38px] flex justify-center items-center hover:bg-gray-100"
          title={t('components.core.text_editor.link_menu.use_file_as_link')}
          onClick={() => {
            inputRef.current?.focus()
            toggleShowFileManager()
          }}
        >
          <i className="fa-light fa-arrow-up-from-bracket text-M" />
        </button>
      </div>
    </div>
  )
}
